module.exports = __webpack_public_path__ + "static/media/birthdays-ai-logo-black.296240c6.png";